import React from 'react';
import PropTypes from 'prop-types';
import { useRequestData } from 'wsm-common-data';

const VehiclePayment = ({ payment }) => {
	const { deviceType } = useRequestData();
	const isMobile = deviceType === 'MOBILE';

	if (!payment) {
		return null;
	}

	const Payment = () => (
		<>
			<span
				key="payment"
				className={`font-weight-bold ${
					isMobile ? 'ddc-font-size-small' : 'ddc-font-size-xlarge'
				}`}
			>
				{payment}
			</span>
			<span
				key="payment-term"
				className={`text-muted ${
					isMobile ? 'ddc-font-size-small' : 'ddc-font-size-xsmall'
				}`}
			>
				{' '}
				/ mo
			</span>
		</>
	);

	const PaymentWrapper = () => (
		<div className="flex-fill border-left">
			<div className="mx-4">
				<Payment />
			</div>
		</div>
	);

	return isMobile ? <Payment /> : <PaymentWrapper />;
};

VehiclePayment.propTypes = {
	payment: PropTypes.string.isRequired
};

export default VehiclePayment;
